"use client";
import { motion } from "framer-motion";
import Image from "next/image";
import beforeImg from "@/../public/images/home/brick-before.jpeg";
import afterImg from "@/../public/images/home/brick-after.jpeg";
import beforeImageTwo from "@/../public/images/home/light-taupe-before.png";
import afterImageTwo from "@/../public/images/home/light-taupe-after.png";
import beforeImageThree from "@/../public/images/home/terracotta-before.jpeg";
import afterImageThree from "@/../public/images/home/terracotta-after.jpeg";

export function BeforeAfterSection() {
  return (
    <section
      id="home-before-after"
      className="py-0 pb-0"
      data-header-scheme="dark"
    >
      <div className="space-y-0">
        {/* Bathroom 1 */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="relative group"
        >
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-0">
            <div className="relative w-full aspect-square overflow-hidden">
              <Image
                src={beforeImg}
                alt="Surface Before Application"
                priority
                placeholder="blur"
                quality={90}
                className="object-cover w-full h-full"
                sizes="(max-width: 1024px) 100vw, 50vw"
              />
              <div className="absolute inset-0 bg-black/40 transition-opacity duration-500 group-hover:opacity-0 z-5"></div>
              <div className="absolute inset-0 flex items-center justify-center z-10 opacity-0 group-hover:opacity-100 transition-opacity duration-500">
                <div className="bg-white/10 backdrop-blur-md text-white px-8 py-4 rounded-2xl font-bold text-2xl shadow-2xl border border-white/20">
                  BEFORE
                </div>
              </div>
            </div>
            <div className="relative w-full aspect-square overflow-hidden">
              <Image
                src={afterImg}
                alt="Surface After Concretta Finish"
                placeholder="blur"
                quality={90}
                className="object-cover w-full h-full"
                sizes="(max-width: 1024px) 100vw, 50vw"
              />
              <div className="absolute inset-0 bg-black/40 transition-opacity duration-500 group-hover:opacity-0 z-5"></div>
              <div className="absolute inset-0 flex items-center justify-center z-10 opacity-0 group-hover:opacity-100 transition-opacity duration-500">
                <div className="bg-white/10 backdrop-blur-md text-white px-8 py-4 rounded-2xl font-bold text-2xl shadow-2xl border border-white/20">
                  AFTER
                </div>
              </div>
            </div>
          </div>
          <div className="absolute inset-0 flex items-center justify-center z-20 pointer-events-none">
            <div className="text-white text-center">
              <h3 className="font-serif text-4xl font-light mb-4 drop-shadow-2xl tracking-tight">
                Modern Brick Concretta Finish
              </h3>
            </div>
          </div>
        </motion.div>
        {/* Bathroom 2 */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
          viewport={{ once: true }}
          className="relative group"
        >
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-0">
            <div className="relative w-full aspect-square overflow-hidden">
              <Image
                src={beforeImageTwo}
                alt="Bathroom Before Renovation 2"
                fill
                sizes="(max-width: 1024px) 100vw, 50vw"
                className="object-cover"
                quality={85}
              />
              <div className="absolute inset-0 bg-black/40 transition-opacity duration-500 group-hover:opacity-0 z-5"></div>
              <div className="absolute inset-0 flex items-center justify-center z-10 opacity-0 group-hover:opacity-100 transition-opacity duration-500">
                <div className="bg-white/10 backdrop-blur-md text-white px-8 py-4 rounded-2xl font-bold text-2xl shadow-2xl border border-white/20">
                  BEFORE
                </div>
              </div>
            </div>
            <div className="relative w-full aspect-square overflow-hidden">
              <Image
                src={afterImageTwo}
                alt="Bathroom After Concretta 2"
                fill
                sizes="(max-width: 1024px) 100vw, 50vw"
                className="object-cover"
                quality={85}
              />
              <div className="absolute inset-0 bg-black/40 transition-opacity duration-500 group-hover:opacity-0 z-5"></div>
              <div className="absolute inset-0 flex items-center justify-center z-10 opacity-0 group-hover:opacity-100 transition-opacity duration-500">
                <div className="bg-white/10 backdrop-blur-md text-white px-8 py-4 rounded-2xl font-bold text-2xl shadow-2xl border border-white/20">
                  AFTER
                </div>
              </div>
            </div>
          </div>
          <div className="absolute inset-0 flex items-center justify-center z-20 pointer-events-none">
            <div className="text-white text-center">
              <h3 className="font-serif text-4xl font-light mb-4 drop-shadow-2xl tracking-tight">
                Light-Taupe Microcement
              </h3>
            </div>
          </div>
        </motion.div>
        {/* Bathroom 3 */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.4 }}
          viewport={{ once: true }}
          className="relative group"
        >
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-0">
            <div className="relative w-full aspect-square overflow-hidden">
              <Image
                src={beforeImageThree}
                alt="Bathroom Before Renovation 3"
                fill
                sizes="(max-width: 1024px) 100vw, 50vw"
                className="object-cover"
                quality={85}
              />
              <div className="absolute inset-0 bg-black/40 transition-opacity duration-500 group-hover:opacity-0 z-5"></div>
              <div className="absolute inset-0 flex items-center justify-center z-10 opacity-0 group-hover:opacity-100 transition-opacity duration-500">
                <div className="bg-white/10 backdrop-blur-md text-white px-8 py-4 rounded-2xl font-bold text-2xl shadow-2xl border border-white/20">
                  BEFORE
                </div>
              </div>
            </div>
            <div className="relative w-full aspect-square overflow-hidden">
              <Image
                src={afterImageThree}
                alt="Bathroom After Concretta 3"
                fill
                sizes="(max-width: 1024px) 100vw, 50vw"
                className="object-cover"
                quality={85}
              />
              <div className="absolute inset-0 bg-black/40 transition-opacity duration-500 group-hover:opacity-0 z-5"></div>
              <div className="absolute inset-0 flex items-center justify-center z-10 opacity-0 group-hover:opacity-100 transition-opacity duration-500">
                <div className="bg-white/10 backdrop-blur-md text-white px-8 py-4 rounded-2xl font-bold text-2xl shadow-2xl border border-white/20">
                  AFTER
                </div>
              </div>
            </div>
          </div>
          <div className="absolute inset-0 flex items-center justify-center z-20 pointer-events-none">
            <div className="text-white text-center">
              <h3 className="font-serif text-4xl font-light mb-4 drop-shadow-2xl tracking-tight">
                Terracotta Concretta Finish
              </h3>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
